export const API_HOST = process.env.REACT_APP_API_URL;